import { render, staticRenderFns } from "./GetADemoEn.vue?vue&type=template&id=29f05874"
import script from "./GetADemoEn.vue?vue&type=script&lang=js"
export * from "./GetADemoEn.vue?vue&type=script&lang=js"
import style0 from "./GetADemoEn.vue?vue&type=style&index=0&id=29f05874&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports